<template>
    <div class="animated fadeIn">
        <div class="col-md-12"><div variant="accent-danger" class="card">
            <div class="card-header"><div>Welkom!</div></div><div class="card-body">
            <p>Deze applicatie is ontwikkeld ter ondersteuning van de teler bij het nemen van beslissingen omtrent
                de sturing van zijn assimilatiebelichting. De focus hiervan ligt op het energetische verhaal bij
                de sturing van de assimilatiebelichting. Met deze tool kan een vergelijking gemaakt worden tussen
                de werkelijke sturing die gebruikt wordt door de teler en het gebruik van lichtintegratie, en dit
                op vlak van energieverbruik en ontvangen lichthoeveelheid. Belangrijk hierbij op te merken is dat
                alle lichteenheden uitgedrukt worden in mol/m² en niet in J/cm². De reden hiervoor is dat deze
                eenheid bespreekt hoeveel licht op de plant valt en wat de plant kan gebruiken om aan fotosynthese
                te doen (PAR-licht).</p>
            <p>Meer informatie omtrent lichtintegratie en meer algemeen over belichting in de serre kan teruggevonden
                worden in de artikels die terug te vinden zijn via volgende websites:</p>
            <ul>
                <li><a href="https://kce.thomasmore.be/lightman.html" target="_blank">https://kce.thomasmore.be/lightman.html</a></li>
                <li><a href="https://kce.thomasmore.be/glitch.html" target="_blank">https://kce.thomasmore.be/glitch.html</a>
                    bij de subactiviteit 'Energie-efficiënte belichtingstechnieken'</li>
            </ul>
        </div></div></div>

        <div class="col-md-12"><div variant="accent-danger" class="card">
            <div class="card-header"><div>Uitleg bij het gebruik van de belichtingstool</div></div><div class="card-body">
            <p>In de linkerkolom op deze website vind je twee grote rubrieken, namelijk 'Beheer' en 'Weer'.
                De rubriek 'Weer' is onderverdeeld twee tabbladen: 'Voorspelling' en 'Weerstation'.
                Bij 'Voorspelling' kan je zien hoeveel licht verwacht kan worden in een bepaalde provincie en
                dit voor de volgende vijf dagen. Deze getallen zijn gebaseerd op data die ter beschikking gesteld
                worden door Elia. Bij het tabblad 'Weerstation' kan je historische weergegevens terugvinden die
                opgemeten werden met een weerstation dat geïnstalleerd is op het dak van Thomas More Kempen in Geel.</p>
            <p>De rubriek 'Beheer' bevat drie tabbladen. Het tabblad 'Bedrijven' geeft een overzicht van de bedrijven
                waar de gebruiker toegang toe heeft en geeft de mogelijkheid om de gegevens er van aan te passen. Het
                tabblad 'Afdelingen' geeft een overzicht van de verschillende afdelingen die per bedrijf aanwezig zijn.
                Belangrijk hierbij is dat de gegevens omtrent de geïnstalleerde belichting hier aangepast dienen te worden.
                Het laatste, en belangrijkste tabblad is 'Afdelingen'. Hier wordt een overzicht gegeven van de belichting
                bij de verschillende teelten. Instellingen omtrent de lichtintegratie kunnen hier per teelt worden
                aangepast. Achter elke teelt staan een aantal symbolen. Hieronder kan je de uitleg er van vinden.</p>
            <table class="table table-sm table-nonfluid">
                <tbody>
                    <tr><td class="center"><i class="fa fa-pencil-square-o blauw"></i></td>
                        <td>Mogelijkheid tot wijzigen van de eigenschappen van het toegepaste lichtintegratie-schema</td>
                    </tr>
                    <tr><td class="center"><i class="fa fa-thermometer-0 blauw"></i></td>
                        <td>Instellen van de gewenste DLI</td>
                    </tr>
                    <tr><td class="center"><i class="fa fa-lightbulb-o blauw"></i></td>
                        <td>Ingeven van het werkelijk gebruikte belichtingsschema</td>
                    </tr>
                    <tr><td class="center"><i class="fa fa-sun-o blauw"></i></td>
                        <td>Detailanalyse van de assimilatiebelichting als ze gestuurd zou worden volgens lichtintegratie</td>
                    </tr>
                    <tr><td class="center"><i class="fa fa-line-chart blauw"></i></td>
                        <td>Samenvatting en vergelijking van de belichting aangestuurd met het werkelijke belichtingsschema en lichtintegratie</td>
                    </tr>
                    <tr><td class="center"><i class="fa fa-clock-o blauw"></i></td>
                        <td>Tabblad waarin een voorstel wordt gedaan om de belichting aan te sturen bij gebruik van lichtintegratie</td>
                    </tr>
                </tbody>
            </table>
            <p>
                Bij vragen bij het gebruik van deze belichtingstool of wanneer je wenst dat we jouw gegevens verwijderen, gelieve ons dan te contacteren op volgend e-mailadres:
                <a href="mailto:kce@thomasmore.be">kce@thomasmore.be</a> of
                <a href="mailto:jeroen.vanroy@thomasmore.be">jeroen.vanroy@thomasmore.be</a>
            </p>
        </div></div></div>

        <div class="col-md-12"><div variant="accent-danger" class="card">
            <div class="card-body smaller">
            <p>Disclaimer:</p>
            <p>Het advies volgend uit deze tool komt tot stand op basis van de door de teler verstrekte gegevens en een aantal inschattingen.</p>
            <p>De dienstverleners kunnen niet verantwoordelijk worden gesteld voor de resultaten van de berekening of bedrijfsresultaten na implementatie van het advies.</p>
            <p>Alle rechten voorbehouden. Niets uit deze uitgave mag worden vermenigvuldigd en/of openbaar gemaakt door middel van druk, fotokopie of op welke andere wijze
                dan ook zonder voorafgaande toestemming van het bedrijf en de dienstverlener.<br/>&nbsp;</p>

            <div class="col-md-12">
                <div class="panel panel-flat">
                    <div class="panel-body divMulti">
                        <div class="row">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <td class="align-middle"><img :src="images.eu" height="55" /></td>
                                    <td class="align-middle"><img :src="images.provincie" height="65" /></td>
                                    <td class="align-middle"><img :src="images.agentschap" height="65" /></td>
                                    <td class="align-middle"><img :src="images.glitch" height="60" /></td>
                                    <td class="align-middle"><img :src="images.tm" height="50" /></td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

        </div></div></div>

    </div>
</template>

<script>
export default {
    name: 'dashboard',
    data () {
        return {
            images: {
                eu: process.env.IMG_DIR + "/" + "eu.jpg",
                provincie: process.env.IMG_DIR + "/" + "provincie.png",
                agentschap: process.env.IMG_DIR + "/" + "agentschap.jpg",
                glitch: process.env.IMG_DIR + "/" + "glitch.png",
                tm: process.env.IMG_DIR + "/" + "tm.png",
            }
        };
    },
};
</script>

<style>
    .blauw {
        color: #00aced;
        font-size: large;
    }

    .table-nonfluid {
        width: auto !important;
    }

    .center {
        text-align: center;
    }

    .smaller {
        font-size: smaller;
    }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue